export const en = {
    global: {
        Submit: 'Confirm',
        Export: 'Export',
        New: 'New',
        Yes: 'Yes',
        No: 'No',
        Filter: 'Filter',
        Reset: 'Reset',
        Update: 'Update',
        Delete: 'Delete'
    },
    swal: {
        general: {
            Title: 'Are you sure?',
            CancelButtonText: 'Cancel'
        },
        logout: {
            Title: 'Are you sure?',
            Text: 'You will return to the login page.',
            ConfirmButtonText: 'Yes, log me out!',
            CancelButtonText: 'Cancel',
            SuccessTitle: "Saved!",
            SuccessMsg: "Form has been saved successfully."
        },
        approve: {
            Title: 'Are you sure?',
            Text: 'Measurements will be visible for customer.',
            ConfirmButtonText: 'Yes, approve now.',
            CancelButtonText: 'Cancel'
        },
        delete: {
            Text: 'This item will be deleted.',
            ConfirmButtonText: 'Yes, delete now.',
            SuccessTitle: "Deleted!",
        }
    },
    sidebar: {
        NewMeasurement: 'New measurement',
        Overview: 'Overview',
        Monitoring: 'Monitoring',
        Components: 'Components',
        Customers: 'Customers',
        Users: 'Users',
        Brands: 'Brands',
        Logout: 'Logout'
    },
    router: {
        OverviewMeasurements: 'Overview measurements',
        NewMeasurement: 'New measurement',
        UpdateMeasurement: 'Edit measurement',
        MonitoringMeasurements: 'Monitoring measurements',
        OverviewComponents: 'Overview components',
        NewComponent: 'New component',
        UpdateComponent: 'Edit component',
        ViewComponent: 'Details component',
        OverviewComponenttypes: 'Overview types',
        NewComponenttype: 'New type',
        UpdateComponenttype: 'Edit type',
        OverviewCustomer: 'Overview customers',
        NewCustomer: 'New customer',
        UpdateCustomer: 'Edit customer',
        OverviewUsers: 'Overview users',
        CreateUser: 'New user',
        UpdateUser: 'Edit user',
        OverviewBrands: 'Overview brands',
        NewBrand: 'New brand',
        UpdateBrand: 'Edit brand',
    },
    table: {
        NoData: 'No data available.',
        NextLabel: 'Next',
        PrevLabel: 'Previous',
        RowsPerPageLabel: 'Rows per page',
        OfLabel: 'of',
        PageLabel: 'page', // for 'pages' mode
        AllLabel: 'All',
    },
    landingpage: {
        SignIn: 'Sign In',
        banner1: {
            Title: 'Need a repetitive maintenance for your industrial process components?',
            Button: 'Contact us'
        },
        sectionIcons: {
            column1: {
                Title: 'Full Traceability',
                Content: 'We feed each component into our internal tool so that all data is analyzed for the best possible maintenance.',
            },
            column2: {
                Title: 'Unique Identification',
                Content: 'Each component we receive for maintenance is given a unique number.',
            },
            column3: {
                Title: 'Multi Step Treatment',
                Content: 'We specialize in cleaning various components, like ball valves or flame arrestors.',
            }
        },
        section1: {
            Title: 'Follow-up program support for repetitive cleaning',
            Content: 'Each component we receive for maintenance is given a unique number and is entered into our internal tool. This tool stores and analyses all technical data for each component. This way we know when the best maintenance interval is for the component.',
            Content2: 'You will also have access to this system to view the data of your components!'
        },
        section2: {
            Title: 'Forfull you legal requirements!',
            Content: 'The maintenance of some process components is mandatory. We take care of the necessary maintenance and provide digital cleaning certificates.',
            Content2: 'We arrange transportation from and to your facility!'
        },
        section3: {
            Title: 'Multi Step Treatment',
            Content: 'We specialize in the maintenance of components. This internal tool is very suitable for the following components: ball valves, stirene removal, pressure vaccuum valves and flame arrestors.'
        },
        sectionExamples: {
            Title: 'Some examples of components that we clean...',
            Example1: 'Ball Valves',
            Example2: 'Flame Arrestors',
            Example3: 'Pressure Valves'
        },
        banner2: {
            Title: 'Ready to get started? Contact us now!',
            Button: 'Contact us'
        },
    },
    measurement: {
        Measurement: 'Measurement',
        Customer: 'Customer',
        Component: 'Sub part',
        Pollution_rate: 'Pol. rate',
        Date: 'Date',
        Note: 'Note',
        BtnApprove: 'Approve',
        Clean: 'Clean',
        Dirty: 'Dirty',
        Approved: 'Approved',
        Type: 'Type',
        Wear_rate: 'Wear rate',
        Rates: 'Rates',
        None: 'None',
        Much: 'Much',
        Packet: 'Process component',
        Back_pressure_rate: 'Back pressure',
        Weight_rate: 'Weight',
        Filter_measurements: 'Extra measurements',
        Leakage_rate: 'Leakage',
        Brand: 'Brand',
        in_date: 'IN',
        control_date: 'Control',
        Actions: 'Actions'
    },
    component: {
        Types: 'Types',
        Number: 'Sub part',
        PacketNumber: 'Process component',
        IntervalControl: 'Cleaning frequentie',
        ComponentTypeId: 'Type',
        CustomerId: 'Customer',
        CreateSuccess: 'Component saved successfully!',
        Customer: 'Customer',
        Type: 'Type',
        max_pollution_rate: 'Max. pollution',
        max_wear_rate: 'Max. wear',
        min_wear_rate: 'Min. wear',
        min_weight_rate: 'Min. weight',
        max_weight_rate: 'Max. weight',
        min_back_pressure_rate: 'Min. backpressure',
        max_back_pressure_rate: 'Max. backpressure',
        max_leakage_rate: 'Max. leakage',
        min_leakage_rate: 'Min. leakage',
        Brand: 'Brand',
        Note: 'Note',
        Max: 'Max',
        Min: 'Min',
        weight: 'Weight (gr)',
        backpressure: 'Backpressure (mm/h2o)',
        leakage: 'Leakage',
        pollution: 'Pollution',
        wear: 'Wear',
        Actions: 'Actions',
        Status: 'Status'
    },
    componenttype: {
        Name: 'Name',
        IntervalControl: 'Control',
        CreateSuccess: 'Type saved successfully!',
        IntervalControlCreate: 'Control in number of months, e.g. 6',
        General: 'General',
        MinMax: 'Min/Max values',
    },
    customer: {
        Name: 'Name',
        CreateSuccess: 'Customer saved successfully!'
    },
    brand: {
        Name: 'Name'
    }
}
